/* 
 * Enums for SlideLayout component
 * NEXT - action to navigate to the next column
 * PREV - action to navigate to the previous column
 */
export enum SlideAction {
  NEXT = 'next',
  PREV = 'prev',
  SINGLE = 'single',
  DUAL = 'dual',
}

/* 
 * Enums for SlideLayout view modes
 * SINGLE - only one column visible
 * DUAL - two columns visible
 */
export enum ViewMode {
  SINGLE = 'single',
  DUAL = 'dual',
}